/**
 * "Hämta nya kvitton": scan the remote Inkorg, put what is new into Att göra
 * and start reading it. One helper for every button that asks for it — the
 * refresh on Att göra, "Hämta ändringar" on the provider page, "Klart" under
 * the phone QR — so they cannot drift. Hem's background pass does the same
 * through its own progress reporting.
 */
import { scanInbox, type ScanResult } from '@/cloud/sync/inbox-scan';
import { inboxService } from '@/domain/inbox/service';
import type { Uuid } from '@/domain/types';

export async function fetchNewReceipts(companyId: Uuid): Promise<ScanResult> {
  const result = await scanInbox(companyId, async (file) => {
    await inboxService.addFiles(companyId, [{ blob: file.blob, name: file.name, source: 'drive', driveFileId: file.id }]);
  });
  if (result.found > 0) void inboxService.process(companyId);
  return result;
}
